"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineRdProjectEligibility = exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING = void 0;
exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING = {
    NotQualifiedTechnicalUncertaintyReasoning: 'The project does not meet the permitted purpose requirement for the R&D Credit under Sections 41 and 174, because substantially all of the project did not involve technical uncertainties.',
    EligibleCustomerFacingReasoning: "This project meets the permitted purpose requirement for the R&D Credit under Sections 41 and 174. Substantially all of the project's work involved addressing core technical uncertainties and followed a process of experimentation and the project was focused on customer-facing product/process.",
    EligibleInternalUseInnovativeReasoning: "This project meets the permitted purpose requirement for the R&D Credit under Sections 41 and 174. Substantially all of the project's work involved addressing core technical uncertainties and followed a process of experimentation. The project focused on internal-use software, but it meets the high threshold for innovation, involved significant economic risk, and was not commercially available.",
    NotQualifiedInternalUseReasoning: 'The project does not meet the permitted purpose requirement for the R&D Credit under Sections 41 and 174. The project focuses on internal use software and does not meet the more stringent requirements of high innovation, significant economic risk, and not being commercially available.',
};
const determineRdProjectEligibility = (answers) => {
    // Q1
    if (answers.isTechnicallyUncertain == null)
        return { status: 'pending', currentQuestionIndex: 1 };
    if (answers.isTechnicallyUncertain === false)
        return {
            status: 'complete',
            outcome: 'NOT_QUALIFIED',
            currentQuestionIndex: 1,
            qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.NotQualifiedTechnicalUncertaintyReasoning,
        };
    // Q2
    if (answers.isCustomerFacingDevelopment == null)
        return { status: 'pending', currentQuestionIndex: 2 };
    if (answers.isCustomerFacingDevelopment === true)
        return {
            status: 'complete',
            outcome: 'ELIGIBLE',
            currentQuestionIndex: 2,
            qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.EligibleCustomerFacingReasoning,
        };
    // Q3
    if (answers.isInnovativeAndRisky == null)
        return { status: 'pending', currentQuestionIndex: 3 };
    if (answers.isInnovativeAndRisky === true) {
        return {
            status: 'complete',
            outcome: 'ELIGIBLE',
            currentQuestionIndex: 3,
            qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.EligibleInternalUseInnovativeReasoning,
        };
    }
    else {
        return {
            status: 'complete',
            outcome: 'NOT_QUALIFIED',
            currentQuestionIndex: 3,
            qualifiedPurposeReasoning: exports.RD_PROJECT_ELIGIBILITY_QUALIFIED_PURPOSE_REASONING.NotQualifiedInternalUseReasoning,
        };
    }
};
exports.determineRdProjectEligibility = determineRdProjectEligibility;
